import {
  AssessmentButton,
  RightSidePanel,
  showToast,
  Tooltip,
  useClickOutsideListenerRef,
} from "ui-components";
import {
  convertDate,
  copyText,
  removeFromQueryParams,
  setInQueryParams,
} from "../../../utils/Common/Constant";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import UserImage from "../../../utils/Images/UserImage";
import { notifyAnApplicant } from "../../../service/Scope/Scope";
import { useState } from "react";
import NotifyConfirmPopup from "../CreateAssessmentResponseList/NotifyConfirmPopup/NotifyConfirmPopup";
import { resendInviteAnApplicant } from "../../../service/Invite/Invite";
import DownloadReportBtn from "../AssessmentReport/DownloadReportBtn";
import FollowUpChat from "../../../components/FollowUpChat/FollowUpChat";
import FollowUpIcon from "../../../utils/Images/FollowUpIcon";
import MoreIcon from "../../../utils/Images/MoreIcon";
import QuestionReportIcon from "../../../utils/Images/QuestionReportIcon";
interface ContentList {
  assessmentApplicantList: any;
  assessmentDetail: any;
  setIsNotified: any;
}
const ContentList: React.FC<ContentList> = ({
  assessmentApplicantList,
  assessmentDetail,
  setIsNotified,
}) => {
  const { t, i18n } = useTranslation();
  // Get current language
  const currentLanguage = i18n.language;
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const assessmentId = assessmentDetail?.assessmentId;
  const companyUserId: any = localStorage.getItem("companyUserId");
  const [notifyBtnDisable, setNotifyBtnDisable] = useState(false);
  const [openMenuId, setOpenMenuId] = useState(null);
  const [searchParams] = useSearchParams();
  const followupBar = searchParams.get("followup");
  const [openFollowupSidebar, setOpenFollowupSidebar] = useState<any>(
    followupBar ?? null,
  );
  const [applicantId, setApplicantId] = useState(() => {
    const applicantId = new URLSearchParams(location.search).get("apllid");
    return applicantId ? applicantId : "";
  });
  const [isNotifyPopupVisible, setIsNotifyPopupVisible] = useState(() => {
    const notifyConfirmation = new URLSearchParams(location.search).get(
      "notifyConfirmation",
    );
    return notifyConfirmation ? JSON.parse(notifyConfirmation) : false;
  });
  const checkedStatus = (status: string, applicantId: string) => {
    if (status !== "Submitted" && status !== "Barred") {
      return;
    }
    navigate(
      `/${currentLanguage}/assessment/response/${assessmentId}?aplid=${applicantId}`,
    );
  };
  // Redirect on Question Report
  const handleReport = (applicantId: string) => {
    navigate(
      `/${currentLanguage}/assessment/report/${assessmentId}/${applicantId}`,
    );
  };
  // review status functional work
  const reviewStatusCheck = (
    status: string,
    resultStatus: string | null,
    finalScore: any,
    evaluationPending: boolean,
  ) => {
    if (
      status === "New" ||
      status === "Deferred" ||
      status === "Initiated" ||
      status === "Terminated"
    ) {
      return "-";
    } else if (finalScore === null) {
      if (evaluationPending) {
        return `${t("GENERAL.AI_ANALYSIS_PROGRESS")}`;
      } else {
        return `${t("GENERAL.MANUAL_PENDING")}`;
      }
    } else if (resultStatus === null) {
      return "Selection Pending";
    } else if (resultStatus === "Hold") {
      return t("RESPONSE_LIST.ON_HOLD");
    } else {
      return resultStatus;
    }
  };
  //this function used to open notify confirmation popup
  const onNotifyClick = (applicantId: any) => {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    url.searchParams.set("notifyConfirmation", "true");
    url.searchParams.set("apllid", applicantId);
    history.replaceState({}, "", url.toString());
    setIsNotifyPopupVisible(true);
    setApplicantId(applicantId);
  };
  //this function used to notify applicant
  const notifyAnApplicantApi = async () => {
    setNotifyBtnDisable(true);
    const data = {
      companyUserId,
      assessmentId: assessmentDetail?.assessmentId,
      applicantId,
    };
    try {
      const res = await notifyAnApplicant(data);
      if (res?.status === 200) {
        const currentUrl = window.location.href;
        const url = new URL(currentUrl);
        url.searchParams.set("notifyConfirmation", "false");
        history.replaceState({}, "", url.toString());
        const isPopUpOpen: any = new URLSearchParams(location.search).get(
          "notifyConfirmation",
        );
        setIsNotifyPopupVisible(JSON.parse(isPopUpOpen));
        showToast(res?.customMessage, "success");
        setIsNotified(Math.random() * 10);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setNotifyBtnDisable(false);
    }
  };
  // resend invitation
  const reSendInvitation = async (emailId: string | number) => {
    const data = {
      assessmentId,
      emailId,
    };
    try {
      // Set isSubmitting to true to indicate that form submission is in progress
      if (emailId) {
        const sendInvitationRes = await resendInviteAnApplicant(data);
        if (sendInvitationRes?.data?.status === 200) {
          showToast(sendInvitationRes?.data?.customMessage, "success");
        } else {
          showToast(sendInvitationRes?.data?.customMessage, "error");
        }
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };
  const toggleMenu = (id: null) => {
    setOpenMenuId((prevId) => (prevId === id ? null : id));
  };
  const openMenuRef = useClickOutsideListenerRef(() => {
    setOpenMenuId(null);
  });
  return (
    <>
      {assessmentApplicantList?.map((item: any, index: number) => {
        const scoreValue =
          item?.finalScore?.score != null
            ? item.finalScore.score + "%"
            : item?.finalScore
              ? "0%"
              : "-";

        const scoreBorderClass =
          item?.remark === "Below Par"
            ? "redBorder"
            : item?.remark === "Good"
              ? "goldenBorder"
              : item?.remark === "Satisfactory"
                ? "orangeBorder"
                : item?.remark === "Excellent"
                  ? "blueBorder"
                  : "";
        return (
          <>
            <div className={"userDetailsSect"} key={index}>
              {/* User Image */}
              <div className="detailsBox">
                <div className="userDetailsSection" key={index}>
                  <div className="userImageDiv">
                    <div
                      className={`userImageBorder ${(item?.applicationStatus === "Submitted" || item?.applicationStatus === "Barred") && "pointerCursor"}`}
                      onClick={() => {
                        (item?.applicationStatus === "Submitted" ||
                          item?.applicationStatus === "Barred") &&
                          checkedStatus(
                            item?.applicationStatus,
                            item?.applicantId,
                          );
                      }}
                    >
                      {item?.profilePic === null ? (
                        <UserImage />
                      ) : (
                        <img src={item?.profilePic} alt="" />
                      )}
                    </div>
                    <div className="notified-text">
                      {item?.isNotified && <span>{t("GENERAL.NOTIFY")}</span>}
                    </div>
                  </div>
                  {/* Middle user details */}
                  <div className="middleSection">
                    <div className="middleUserDetails">
                      <div className="heading userEmailDiv">
                        <h3
                          className="userName"
                          onClick={() => {
                            checkedStatus(
                              item?.applicationStatus,
                              item?.applicantId,
                            );
                          }}
                        >
                          {item?.displayName ?? "-"}
                        </h3>
                        <h5
                          title={item?.emailId}
                          onClick={() => copyText(item?.emailId)}
                        >
                          {item?.emailId ?? "-"}
                        </h5>
                        <h5>{item?.mobile ?? "-"}</h5>
                      </div>
                      <div className="heading">
                        <h4>{t("GENERAL.ASSESSMENT.STATUS")}</h4>
                        <div className="assessmentStatusDiv">
                          <h3>{item?.applicationStatus ?? "-"}</h3>
                          {item?.applicationStatus === "Terminated" ||
                          item?.applicationStatus === "Barred" ? (
                            <div className="iIcon">
                              <Tooltip
                                classname="tooltipOverCss"
                                text={t(
                                  item?.applicationStatus === "Barred"
                                    ? "RESPONSE_LIST.BARRED_TOOLTIP"
                                    : "RESPONSE_LIST.BLOCKED_TOOLTIP",
                                )}
                              />
                            </div>
                          ) : null}
                        </div>
                        <h5>{convertDate(item?.updatedAt, false, true)}</h5>
                      </div>
                      <div className="heading">
                        <div className="d-flex gap-1 ">
                          <h4>{t("GENERAL.RESULT_STATUS")}</h4>
                          {/* new code */}
                          <div className="followupIcon">
                            {item?.applicationStatus !== "New" && (
                              <div className="followupIconSec">
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    toggleMenu(item?.applicantId);
                                  }}
                                  className="cursor-pointer"
                                >
                                  <MoreIcon />
                                </div>
                              </div>
                            )}

                            {/* Show/Hide toggleBox */}
                            {openMenuId === item?.applicantId && (
                              <div
                                className="followUpContent"
                                ref={openMenuRef}
                              >
                                <div className="">
                                  {item?.applicationStatus !== "New" && (
                                    <div
                                      className="cursor-pointer followBtnSec"
                                      onClick={() => {
                                        setOpenFollowupSidebar(
                                          item?.applicantId,
                                        );
                                        setInQueryParams(
                                          queryParams,
                                          "followup",
                                          item?.applicantId,
                                          navigate,
                                        );
                                      }}
                                      title={t("GENERAL.FOLLOW_UP")}
                                    >
                                      <FollowUpIcon />
                                      <p>{t("GENERAL.FOLLOW_UP")}</p>
                                    </div>
                                  )}
                                </div>
                                {item?.isNotified && (
                                  <div className="followBtnSec downBtn">
                                    <div
                                      title={t("RESPONSE_LIST.REPORT_READY")}
                                    >
                                      <DownloadReportBtn
                                        applicantId={item?.applicantId}
                                        assessmentIdParam={assessmentId}
                                        label={t("GENERAL.DOWNLOAD_REPORT")}
                                        downloadingLabel={t(
                                          "GENERAL.REPORT_DOWLOADING",
                                        )}
                                      />
                                    </div>
                                  </div>
                                )}
                                <div
                                  className="followBtnSec downBtn"
                                  onClick={() => handleReport(item.applicantId)}
                                >
                                  <QuestionReportIcon />
                                  <p>{t("GENERAL.DETAILED_REPORT")}</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                        <h3>
                          {reviewStatusCheck(
                            item?.applicationStatus,
                            item?.resultStatus,
                            item?.finalScore,
                            item?.evaluationPending,
                          )}
                        </h3>
                        <h5
                          className={`${item?.remark === "Below Par" ? "color-light-red" : item?.remark === "Good" ? "color--primary-golden" : item?.remark === "Satisfactory" ? "color-safety-orange" : item?.remark === "Excellent" ? "color--primary-blue" : ""}`}
                        >
                          {item?.remark}
                        </h5>
                      </div>
                    </div>
                    {(item?.applicationStatus === "Submitted" ||
                      item?.applicationStatus === "Barred") && (
                      <div className="detailsLowerSec">
                        <div className="otherScoresSection">
                          <div className="otherScores">
                            <div className="scoresViewBtn">
                              <div className="scoreDetails">
                                <div className="scoreItem">
                                  <span className="label">
                                    {t("RESPONSE_LIST.COMMUNICATION")}
                                  </span>
                                  <span className="value">
                                    {item?.finalScore !== null &&
                                    item?.finalScore?.communicationScore !==
                                      null
                                      ? item?.finalScore?.communicationScore +
                                        "%"
                                      : "-"}
                                  </span>
                                </div>
                                <div className="scoreItem">
                                  <span className="label">
                                    {t("RESPONSE_LIST.VISUAL_ANALYSIS")}
                                  </span>
                                  <span className="value">
                                    {item?.finalScore !== null &&
                                    item?.finalScore?.visualScore !== null
                                      ? item?.finalScore?.visualScore + "%"
                                      : "-"}
                                  </span>
                                </div>
                                <div className="scoreItem">
                                  <span className="label">
                                    {t("RESPONSE_LIST.VOICE_ANALYSIS")}
                                  </span>
                                  <span className="value">
                                    {item?.finalScore !== null &&
                                    item?.finalScore?.voiceScore !== null
                                      ? item?.finalScore?.voiceScore + "%"
                                      : "-"}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  {/* View buttn*/}
                  <div className="viewSection">
                    <div className="heading ">
                      <h4>{t("GENERAL.SCORE")}</h4>
                      <div className="d-flex align-items-center gap-2">
                        <div>
                          {scoreValue !== "-" ? (
                            <DownloadReportBtn
                              applicantId={item?.applicantId}
                              assessmentIdParam={assessmentId}
                              label={t("RESPONSE_LIST.REPORT_READY")}
                              downloadingLabel={t("GENERAL.REPORT_DOWLOADING")}
                            >
                              <span
                                className={`scoreText cursorPointer ${scoreBorderClass}`}
                                title="Click the score to download the report"
                              >
                                {scoreValue}
                              </span>
                            </DownloadReportBtn>
                          ) : (
                            <span className={`scoreText ${scoreBorderClass}`}>
                              {scoreValue}
                            </span>
                          )}
                          <br />
                        </div>
                      </div>
                    </div>
                    <div className="btnRowNotify">
                      {!item?.isNotified &&
                        (item?.resultStatus === "Shortlisted" ||
                          item?.resultStatus === "Rejected") && (
                          <AssessmentButton
                            className={`viewBtn ${notifyBtnDisable && "notifyBtnDisable"}`}
                            disabled={notifyBtnDisable}
                            onClick={() => {
                              onNotifyClick(item?.applicantId);
                            }}
                          >
                            {t("GENERAL.NOTIFY_TEXT")}
                          </AssessmentButton>
                        )}
                      {(item?.applicationStatus === "Submitted" ||
                        item?.applicationStatus === "Barred") && (
                        <AssessmentButton
                          className="viewBtn"
                          onClick={() => {
                            checkedStatus(
                              item?.applicationStatus,
                              item?.applicantId,
                            );
                          }}
                        >
                          {t("GENERAL.VIEW")}
                        </AssessmentButton>
                      )}
                      {item?.applicationStatus === "New" && (
                        <AssessmentButton
                          className="viewBtn mb-3"
                          onClick={() => {
                            reSendInvitation(item?.emailId);
                          }}
                        >
                          {t("GENERAL.RE_INVITE")}
                        </AssessmentButton>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <RightSidePanel
                show={openFollowupSidebar === item.applicantId}
                handleClose={() => {
                  setOpenFollowupSidebar(false);
                  removeFromQueryParams(queryParams, "followup", navigate);
                  localStorage.removeItem("lastMessageTime");
                }}
                title={item?.displayName}
                className="followUpChatPanel"
              >
                <div
                  className={`userImageBorder ${(item?.applicationStatus === "Submitted" || item?.applicationStatus === "Barred") && "pointerCursor"}`}
                >
                  {item?.profilePic === null ? (
                    <UserImage />
                  ) : (
                    <img src={item?.profilePic} alt="" />
                  )}
                </div>
                <FollowUpChat
                  assessmentTitle={assessmentDetail?.title}
                  applicantId={item.applicantId}
                  assessmentId={assessmentId}
                  invitedOn={item?.invitedOn}
                  submittedOn={item?.submittedOn}
                  resultStatus={item?.resultStatus}
                />
              </RightSidePanel>
            </div>
          </>
        );
      })}
      {isNotifyPopupVisible && (
        <NotifyConfirmPopup
          isPopupShow={isNotifyPopupVisible}
          setIsClosePopup={setIsNotifyPopupVisible}
          handleYesPress={notifyAnApplicantApi}
          isDisable={notifyBtnDisable}
        />
      )}
    </>
  );
};

export default ContentList;
